import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocumentItem from "../../../../../Components/Masters/DocumentItem";
import ViewDate from "../../../../../Components/Masters/ViewDate";
import { getMonthName } from "../../../../../utils/getMonthName";
import { truncateNumber } from "../../../../../utils/common";
import { useUser } from "../../../../../context/AuthContext";

function View({
  title,
  inputData,
  data,
  viewData,
  setViewData,
  handleEdit,
}) {
  const [filteredData, setFilteredData] = useState({});
  const { user } = useUser();

  useEffect(() => {
    if (data) {
      console.log(data);
      setFilteredData(data);
    }
  }, [data]);

  const renderField = (value) => (
    <div>
      <span>{truncateNumber(value?.value)} </span>
      <span>{value?.unit}</span>
    </div>
  );

  const renderList=(value)=>(
    <ul style={{marginLeft:"-17px"}}>
      {value?.map(el=>
      <li>{el}</li>)}
    </ul>
  )

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        height: "100vh",
        justifyContent: "space-between",
        backgroundColor: "transparent",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={() => setViewData(false)} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{ p: 3, width: "100%", backgroundColor: "#fff", overflow: "auto" }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          {title} Details
        </Typography>

        <Grid container spacing={2}>
          <ViewDate data={data} />
          {inputData.map((input) => {
            const value = filteredData?.[input.fieldName];

            console.log(input.fieldName,Array.isArray(value));
            // if (value === undefined || value === null) return "null";

            if (
              input.fieldName === "documents" ||
              input?.fieldName === "industrialEquipment"
            )
              return null;

            let displayValue;
            displayValue =
            Array?.isArray(value) ? renderList(value):
              input?.fieldName === "projectLocation"
                ? value?.city + ", " + value?.state + ", " + value?.country
                : input.fieldName === "consumptionPeriod"
                ? getMonthName(value?.month) + " " + value?.year
                : input.fieldName === "calorificValue" ||
                  input.fieldName === "quantityConsumed"
                ? value?.value !== "" && value?.unit !== ""
                  ? renderField(value)
                  : "-"
                : typeof value === "object" && value !== null
                ? value?.industryProcess || value?.name
                : value===0?0 : value || "-";

            return (
              <Grid item xs={12} sm={12} key={input.fieldName}>
                {console.log(input.fieldName)}
                {/* {input.fieldName === "consumptionPeriod" && (
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                      Consumption Month:
                    </Typography>
                    <Box sx={{ display: "flex", gap: 2, my: 2 }}>
                      <Typography
                       >{getMonthName(data?.consumptionPeriod?.month)} + {data?.consumptionPeriod?.year}</Typography>
                      <Typography>{data?.consumptionPeriod?.year} </Typography>
                    </Box>
                  </Box>
                )} */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: "bold",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {input.title}
                </Typography>
                <Typography>
                  {/* {Array.isArray(input.options)
                    ? input.options.includes(displayValue)
                      ? displayValue
                      : "-" */}
                  {displayValue}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Documents (optional)
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ width: "100%" }}
          >
            {/* Render Images First */}
            {data && data.documents.length > 0 ? (
              <>
                {" "}
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {data.documents
                    .filter((url) =>
                      ["png", "jpg", "jpeg"].includes(
                        url.split(".").pop().toLowerCase()
                      )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`image-${index}`} url={url} />
                    ))}
                </Box>
                <Box display="flex" flexWrap="wrap" gap={1}>
                  {data.documents
                    .filter(
                      (url) =>
                        !["png", "jpg", "jpeg"].includes(
                          url.split(".").pop().toLowerCase()
                        )
                    )
                    .map((url, index) => (
                      <DocumentItem key={`file-${index}`} url={url} />
                    ))}
                </Box>
              </>
            ) : (
              <Typography>
                {/* {Array.isArray(input.options)
                    ? input.options.includes(displayValue)
                      ? displayValue
                      : "-" */}
                -
              </Typography>
            )}
          </Box>
        </Box>

        {!user?.companyAdmin && (
          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73", textTransform: "none" }}
            onClick={handleEdit}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  );

  return (
    <Drawer
      anchor="right"
      open={viewData}
      onClose={() => setViewData(false)}
      sx={{
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
        },
      }}
    >
      {list()}
    </Drawer>
  );
}

export default View;
